var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view view__lms_superadmin_customer_add"},[_c('lms-superadmin-customer-add'),_c('pop-notify',{ref:"popNotify",class:'pop__notify--redirect',on:{"emit-submit":_vm.redirect}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }